import React, { Component } from "react";
import { Radio, message, Badge, Spin } from "antd";
import { app, api } from "../../app";
import ReviewFailModal from "../../components/ReviewFailModal";
// import ReNotice from "./ReNotice";
// import ReNews from "./ReNews";
// import Relegal from "./Relegal";
// import Remien from "./Remien";
import Remission from "./Remission";
import Remission2 from "./Remission2";
// import ReReleaseTrain from "./ReReleaseTrain";

class RePush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      review_visible: false,
      reviewInfo: {},
      sel_tab: 0,
      tabs: [],
      audit: {},
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.getAudit();
    if (this.state.tabs.length > 0) {
      await this.setData({ sel_tab: this.state.tabs[0].val });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * 设置值
   * @param data
   */
  setData = (data) => app.setStateSync(this, data);

  /**
   * 审核结果
   * @param audit
   * @param detail
   * @param reviewInfo
   * @param other_params
   * @returns {Promise<boolean>}
   */
  handleCheckReview = async (audit, detail, reviewInfo, other_params) => {
    console.log(reviewInfo)
    app.alert("正在审核~", "loading", "35%", 0);
    const { uri, audit_id, id_key, source,audit_id_str,type } = reviewInfo || this.state.reviewInfo;
    let params = {
      audit,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    params[id_key] = audit_id; //id
    console.log(params)
    if (audit === 2) params.detail = detail;
    if (other_params && other_params instanceof Object)
      params = Object.assign(params, other_params);
    const { flag, msg } = await app.post(uri, params);
    message.destroy();
    if (audit === 2) this.CloseReviewModal();
    if (flag === 1) {
      app.alert("审核成功", "success");
      if (source) source();
      this.getAudit();
      return true;
    } else {
      app.alert(msg, "warn");
      return false;
    }
  };

  /**
   * 获取审核统计
   * @returns {Promise<void>}
   */
  getAudit = async () => {
    const params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg } = await app.post(api.taskAuditCount, params);
    if (flag === 1) {
      let tabs = [];
      if(data.task_audit  == true){
        tabs.push({ val: "1", name: "单队任务", count: "task_count" });
      }
      if(data.task_ally_audit  == true){
        tabs.push({ val: "2", name: "联合任务", count: "task_ally_count" });
      }
      this.setData({ tabs, audit: data });
    } else {
      app.alert(msg, "error");
    }
  };

  /**
   * 打开不通过审核对话框
   * @param reviewInfo
   * @constructor
   */
  OpenReviewModal = (reviewInfo) => {
    this.setData({ review_visible: true, reviewInfo });
  };

  /**
   * 关闭不通过审核对话框
   * @constructor
   */
  CloseReviewModal = () => {
    this.setData({ review_visible: false, reviewInfo: {} });
  };

  /**
   * 审核结果
   * @param rule
   * @param value
   * @param callback
   */
  handleReviewResult = (rule, value, callback) => {
    if (value && value.trim() === "") {
      callback("请输入审核不通过原因！");
    }
    callback();
  };

  /**
   * Tab按钮变换
   * @param e
   */
  handleTabBtnChange = (e) => {
    const { value } = e.target;
    this.setData({ sel_tab: value });
  };

  render() {
    let { review_visible, sel_tab, tabs, audit } = this.state,
      zi_props = {
        successReview: this.handleCheckReview,
        failReview: this.OpenReviewModal,
      };
    let content_node = null;
    switch (sel_tab) {
      case "1": //单队任务
      content_node = <Remission {...zi_props} />;
        break;
      case "2": //联合任务
        content_node = <Remission2 {...zi_props} />;
        break;
      default:
      // content_node = (<ReNews {...zi_props}/>)
      // content_node = (
      //     <div style={{ textAlign: 'center', padding: '3rem 0' }}>
      //         <Spin size="large" tip="正在加载..."/>
      //     </div>
      // )
    }
    return (
      <div className="review-info">
        <div className="page-title">任务审核</div>
        <div className="page-content">
          <div className="review-info-tab">
            <Radio.Group
              value={sel_tab}
              buttonStyle="solid"
              onChange={this.handleTabBtnChange}
            >
              {tabs.map((tab, index) => (
                <Badge style={{zIndex:10}} count={audit[tab.count] || 0} key={index}>
                  <Radio.Button value={tab.val} className="no-select">
                    {tab.name}
                  </Radio.Button>
                </Badge>
              ))}
            </Radio.Group>
          </div>
          <div className="review-info-content">{content_node}</div>
          <ReviewFailModal
            visible={review_visible}
            close={this.CloseReviewModal}
            label={"不通过原因"}
            submit={(detail) => this.handleCheckReview(2, detail)}
          />
        </div>
      </div>
    );
  }
}

export default RePush;



// WEBPACK FOOTER //
// ./src/routes/review/ReTask.jsx